import http from "../../utils/http"

/**
 * 获取分页列表
 */
export function expertPage(params) {
    return http({
        url: "/api/expert/page",
        data: params
    })
}
/**
 * 获取详情
 */
export function expertDetail(params) {
    return http({
        url: "/api/expert/info",
        data: params
    })
}
/**
 * 获取列表
 */
 export function expertList(params) {
    return http({
        url: "/api/expert/list",
        data: params
    })
}

/**
 * 关注
 */
 export function expertCollection(params) {
    return http({
        url: "/api/expert/collection",
        data: params
    })
}

/**
 * 获取我的收藏
 */
 export function expertMyPage(params) {
    return http({
        url: "/api/expert/myPage",
        data: params
    })
}
